module.exports = __webpack_public_path__ + "static/media/2022-02-27 19.09.16.39ecf52b.png";